import { render, staticRenderFns } from "./RegrasSegmentos.vue?vue&type=template&id=69025601&scoped=true"
import script from "./RegrasSegmentos.vue?vue&type=script&lang=js"
export * from "./RegrasSegmentos.vue?vue&type=script&lang=js"
import style0 from "./RegrasSegmentos.vue?vue&type=style&index=0&id=69025601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69025601",
  null
  
)

export default component.exports